/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable unused-imports/no-unused-vars */
import { useEffect, useState } from 'react';

import {
  AccessTextField,
  TertiaryButton,
} from '@changegps/horizon-component-library';
import { Box, Typography } from '@mui/material';

import AccessLogo from '@/assets/img/access_logo.png';
import { useCIMDisconnect, useGetConnection } from '@/features/clients';
import { useGetADEConnect } from '@/features/clients/hooks/use-get-connect';
import { useUserQuery } from '@/features/users';

export const AccessConnect = () => {
  const user = useUserQuery();
  const [isAccessConnected, setIsAccessConnected] = useState(false);
  const [accessToken, setAccessToken] = useState('');

  const { data: _adeConnectData, isLoading } = useGetADEConnect(
    user.data && accessToken.trim()
      ? {
          company_id: user.data.legacy_company_id,
          access_token: JSON.stringify({ id_token: accessToken }),
          user_id: user.data.legacy_user_id,
        }
      : null,
  );

  const { refetch: disconnect } = useCIMDisconnect(
    user.data?.connection_type === 'ADE' || user.data?.connection_type === 'XPM'
      ? user.data.connection_type
      : 'ADE',
  );

  const { data: _adeConnection } = useGetConnection(
    user.data?.connection_type || null,
  );

  useEffect(() => {
    if (_adeConnection && _adeConnection.data) {
      const parsedToken: { id_token: string } = JSON.parse(
        _adeConnection.data.access_token,
      );
      const parseJSON = parsedToken.id_token;
      setAccessToken(parseJSON);
    }
  }, [_adeConnection]);

  useEffect(() => {
    if (user) {
      setIsAccessConnected(
        String(user?.data?.connection_type).toUpperCase() === 'ADE',
      );
    }
  }, [user]);

  useEffect(() => {
    if (_adeConnectData && _adeConnectData.success) {
      void user.refetch(); // Refetch user data when ADE connect data changes
      setIsAccessConnected(true);
    }
  }, [_adeConnectData, user]);

  const handleClick = async () => {
    if (isAccessConnected) {
      await disconnect();
      await user.refetch();
      setIsAccessConnected(false); // Add this line to update the local state
      setAccessToken(''); // Add this line to clear the token
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <img src={AccessLogo} width={100} />
        <Typography>Connect to Access</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <AccessTextField
          disabled={isAccessConnected || user.data?.connection_type === 'XPM'}
          value={accessToken}
          onChange={(e) => setAccessToken(e.target.value)}
          sx={{
            width: '326px',
          }}
        />
        {!isAccessConnected ? (
          <TertiaryButton
            sx={{
              background: '#7DDD36 !important',
              color: 'white !important',
            }}
          >
            {isLoading ? 'Connecting...' : 'Active'}
          </TertiaryButton>
        ) : (
          <TertiaryButton
            sx={{
              background: 'red !important',
              color: 'white !important',
            }}
            onClick={handleClick}
          >
            Disconnect
          </TertiaryButton>
        )}
      </Box>
    </Box>
  );
};
